function headerHeightAnnouncement() {
    var announcementBar = document.querySelector(".section-announcement-bar");
    var header = document.querySelector(".header-wrapper");
    var subMenu = document.querySelectorAll(".header__submenu");
    var barHeight;
    if(announcementBar) {
      barHeight = announcementBar.offsetHeight;
    }
    var headerHeight;
    if(headerHeight) {
      var headerHeight = header.offsetHeight;
    }
    var windowHeight = window.innerHeight;
    var totalheight = headerHeight;
    var headerSection =  document.getElementById('shopify-section-header');
    if(headerSection) {
      if (!headerSection.classList.contains("shopify-section-header-sticky")) {
        totalheight = barHeight + headerHeight;
      }
    }

    if( subMenu.length ) {
        subMenu.forEach(function (item) {
            item.setAttribute('style',`top:${totalheight}px !important;height:${windowHeight - totalheight}px`);
            // item.style.top = totalheight + `px`;
            // item.style.height = windowHeight - totalheight + "px";
        });
    }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('aria-expanded', 'false');
    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        if(event.target.closest('#nav-header')){
            headerHeightAnnouncement()
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            if( summary.classList.contains('second-level-menus') || summary.closest('.hamburger') ) {
            document.body.classList.add('open');
            } else {
                document.querySelector('body').classList.toggle('open');
            }
        }
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

document.addEventListener('DOMContentLoaded', () => {
    headerHeightAnnouncement();
});

window.addEventListener('resize', () => {
    headerHeightAnnouncement();
});

var subMenu = document.querySelectorAll('.second-level-menus');
for (var i = 0; i < subMenu.length; i++) {
    subMenu[i].addEventListener('click', onClickSubMenu);
}

function onClickSubMenu(e) {
    var currentTarget = e.currentTarget;
    var menuParentId = currentTarget.closest('details').getAttribute('id');
    var activeMenus = document.querySelectorAll('.Details-HeaderSubMenu');
    activeMenus.forEach(function (activeMenu) {
     var activeMenuId = activeMenu.getAttribute('id');
        if (menuParentId != activeMenuId) {
            if (activeMenu.hasAttribute('open')) {
                activeMenu.removeAttribute('open');
                activeMenu.querySelector('summary').setAttribute('aria-expanded', 'false');
            }
    }
    });
}
var navHeader = document.getElementById('nav-header');
// document.addEventListener('click', function(event) {
//     var isClickInsideElement = navHeader.contains(event.target);
//     if( !event.target.closest('#nav-header')) {
//         document.body.classList.remove('open');
//         var activeMenus = document.querySelectorAll('.Details-HeaderSubMenu');
//         activeMenus.forEach(function (activeMenu) {
//             if (activeMenu.hasAttribute('open')) {
//                 activeMenu.removeAttribute('open');
//                 activeMenu.querySelector('summary').setAttribute('aria-expanded', 'false');
//             }
//         });
//     }
//     // if (!isClickInsideElement) {
//     //     document.body.classList.remove('open');
//     //     var activeMenus = document.querySelectorAll('.Details-HeaderSubMenu');
//     //     activeMenus.forEach(function (activeMenu) {
//     //         if (activeMenu.hasAttribute('open')) {
//     //             activeMenu.removeAttribute('open');
//     //             activeMenu.querySelector('summary').setAttribute('aria-expanded', 'false');
//     //         }
//     //     });
//     // }
// });


// store submenu

var storeMenu = document.querySelector('.store-menu');
var storeDropdown = document.querySelector('.utility-menu');
if(storeDropdown) {
    storeMenu.addEventListener("click", menuOpen);
    function menuOpen(){
        if( !storeDropdown.classList.contains('show') ){
            storeDropdown.classList.add('show');
        }else{
            storeDropdown.classList.remove('show');
        }
    }
}

(() => {
  let handleMegaMenuEscape = null;

  // Mega Menu
  function megaMenu() {
    let primaryNav = document.getElementById("hasMegaMenu");
    if(primaryNav) {
      const navItems = primaryNav.querySelectorAll(".header__menu-li-js");
      const navItemsNoDrop = primaryNav.querySelectorAll(".header__menu-li-nodrop-js");
      const navWrapper = primaryNav.querySelector(".list-menu--mega");
      const bgBackground = document.querySelector(".hasMegaMenu-overlay");
      let primaryNavHeight = primaryNav.clientHeight;
      let globalDropdownVisibility = primaryNav.querySelectorAll(
        ".dropdown-menu__visibility"
      );

      // Track pending timeouts to cancel them
      let pendingCloseTimeout = null;
      let pendingResetTimeout = null;

      // Helper function to clear all pending timeouts
      function clearPendingTimeouts() {
        if (pendingCloseTimeout) {
          clearTimeout(pendingCloseTimeout);
          pendingCloseTimeout = null;
        }
        if (pendingResetTimeout) {
          clearTimeout(pendingResetTimeout);
          pendingResetTimeout = null;
        }
      }

      // Helper function to close all dropdowns except one (synchronous)
      function closeAllOtherDropdowns(currentNavItem) {
        navItems.forEach((item) => {
          if (item !== currentNavItem && item.classList.contains("header__menu-li--active")) {
            const otherDropdownVis = item.querySelector(".dropdown-menu__visibility");
            const otherTrigger = item.querySelector(".header__menu-item");
            item.classList.remove("header__menu-li--active");
            if (otherDropdownVis) otherDropdownVis.classList.remove("is-visible");
            if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
          }
        });
      }

      // Helper function to open dropdown menu
      function openDropdown(dropdownVisibility, bgBackgroundHeight, trigger, navItem) {
        clearPendingTimeouts();

        closeAllOtherDropdowns(navItem);
        dropdownVisibility.classList.add("is-visible");
        setTransitionStyles("0.17s", "0s");
        primaryNav.classList.add("activated");
        bgBackground.style.height = bgBackgroundHeight + "px";
        document.body.classList.add("nav-overflow-hidden");
        if (trigger) trigger.setAttribute("aria-expanded", "true");
      }

      // Helper function to close dropdown menu
      function closeDropdown(dropdownVisibility, delay = 100, trigger) {
        clearPendingTimeouts();

        // Set transition for closing
        globalDropdownVisibility.forEach((e) => {
          e.style.transitionDelay = "0s";
        });

        // Sync: close immediately
        primaryNav.classList.remove("activated");
        bgBackground.style.height = "0px";
        document.body.classList.remove("nav-overflow-hidden");

        // Delay removing is-visible to allow animation
        pendingCloseTimeout = setTimeout(() => {
          dropdownVisibility.classList.remove("is-visible");
          pendingCloseTimeout = null;

          // Reset transitions after close completes
          resetTransitionsAfterDelay();
        }, delay);

        if (trigger) trigger.setAttribute("aria-expanded", "false");
      }

      // Helper function to set transition styles
      function setTransitionStyles(transitionDelay, transitionDuration) {
        globalDropdownVisibility.forEach((e) => {
          e.style.transitionDelay = transitionDelay;
          e.style.transitionDuration = transitionDuration;
        });
      }

      // Helper function to reset transitions after delay
      function resetTransitionsAfterDelay(delay = 100) {
        pendingResetTimeout = setTimeout(() => {
          globalDropdownVisibility.forEach((e) => {
            e.style.transitionDelay = "0.17s";
          });
          pendingResetTimeout = null;
        }, delay);
      }

      if (navItems) {
        navItems.forEach((navItem) => {
          let dropdownMenu = navItem.querySelector(".dropdown-menu");
          if(dropdownMenu) {
            let dropdownMenuHeight = navItem.querySelector(".dropdown-menu").clientHeight;
            let bgBackgroundHeight = parseInt(dropdownMenuHeight) + parseInt(primaryNavHeight);

            // Function to update the height of the dropdown menu
            function updateDropdownMenuHeight() {
              dropdownMenuHeight = navItem.querySelector(".dropdown-menu").clientHeight;
              bgBackgroundHeight = parseInt(dropdownMenuHeight) + parseInt(primaryNavHeight);
            }
            updateDropdownMenuHeight()

            // Add event listener for window resize based on matchMedia
            let megaMenuDesktopWidth = window.matchMedia("(min-width: 992px)");
            megaMenuDesktopWidth.addEventListener("change", updateDropdownMenuHeight);

            let dropdownVisibility = navItem.querySelector(
              ".dropdown-menu__visibility"
            );
            let trigger = navItem.querySelector(".header__menu-item");

            let isMouseOver = false;

            navItem.addEventListener("mouseenter", (e) => {
              isMouseOver = true;
              navItem.classList.add("header__menu-li--active");
              openDropdown(dropdownVisibility, bgBackgroundHeight, trigger, navItem);
            });

            navItem.addEventListener("mouseleave", (e) => {
              isMouseOver = false;
              navItem.classList.remove("header__menu-li--active");
              closeDropdown(dropdownVisibility, 100, trigger);
            });

            // Keyboard navigation: focus event
            navItem.addEventListener("focusin", (e) => {
              if (navItem.contains(e.target)) {
                navItem.classList.add("header__menu-li--active");
                openDropdown(dropdownVisibility, bgBackgroundHeight, trigger, navItem);
              }
            });

            // Keyboard navigation: blur event
            navItem.addEventListener("focusout", (e) => {
              if (!navItem.contains(e.relatedTarget) && !isMouseOver) {
                navItem.classList.remove("header__menu-li--active");
                closeDropdown(dropdownVisibility, 100, trigger);
              }
            });

            // Close dropdown on Escape key
            navItem.addEventListener("keydown", (e) => {
              if (e.key === "Escape" && navItem.classList.contains("header__menu-li--active")) {
                isMouseOver = false;
                navItem.classList.remove("header__menu-li--active");
                closeDropdown(dropdownVisibility, 100, trigger);
                trigger.focus();
              }
            });
          }
        });
      }

      if (navItemsNoDrop) {
        navItemsNoDrop.forEach((navItemNoDrop) => {
          navItemNoDrop.addEventListener("mouseenter", (e) => {
            clearPendingTimeouts();

            setTransitionStyles("0s", "0s");
            primaryNav.classList.remove("activated");
            bgBackground.style.height = "0px";
            document.body.classList.remove("nav-overflow-hidden");
          });
        });
      }

      navWrapper.addEventListener("mouseleave", () => {
        primaryNav.classList.remove("activated");
        bgBackground.style.height = "0px";
        document.body.classList.remove("nav-overflow-hidden");

        // Reset transitions
        resetTransitionsAfterDelay();
      });

      // Close dropdown on Escape key from anywhere inside the mega menu
      if (handleMegaMenuEscape) {
        document.removeEventListener("keydown", handleMegaMenuEscape);
      }

      handleMegaMenuEscape = (e) => {
        if (e.key === "Escape" && primaryNav.classList.contains("activated")) {
          clearPendingTimeouts();

          navItems.forEach((item) => {
            if (item.classList.contains("header__menu-li--active")) {
              const dropdownVis = item.querySelector(".dropdown-menu__visibility");
              const triggerEl = item.querySelector(".header__menu-item");
              item.classList.remove("header__menu-li--active");
              if (dropdownVis) dropdownVis.classList.remove("is-visible");
              if (triggerEl) triggerEl.setAttribute("aria-expanded", "false");
            }
          });
          primaryNav.classList.remove("activated");
          bgBackground.style.height = "0px";
          document.body.classList.remove("nav-overflow-hidden");
        }
      };

      document.addEventListener("keydown", handleMegaMenuEscape);
    }
  }

  function multipleDrawerMenuMobile() {
    let primaryNav = document.getElementById("hasMegaMenu");
    if(primaryNav) {
      const navItemsMobile = primaryNav.querySelectorAll(".header__menu-li-mobile-js");
        navItemsMobile.forEach((navItem) => {

          let dropdownMenu = navItem.querySelector(".dropdown-menu");
          let navItemLink = navItem.querySelector(".menu-drawer__menu-item");
          if (dropdownMenu) {
            let backButton = navItem.querySelector(".secondDrawer-back-js");
            let crossButton = navItem.querySelector(".secondDrawer-cross-js");
            let focusableElements = dropdownMenu.querySelectorAll("a:not(.secondDrawer-back-js):not(.secondDrawer-cross-js), button:not(.secondDrawer-back-js):not(.secondDrawer-cross-js), [tabindex]:not([tabindex='-1']):not(.secondDrawer-back-js):not(.secondDrawer-cross-js)");

            // Set all focusable elements to non-focusable initially
            function disableFocusInDropdown() {
              focusableElements.forEach((element) => {
                element.setAttribute("tabindex", "-1");
              });
            }

            // Enable focus on all focusable elements
            function enableFocusInDropdown() {
              focusableElements.forEach((element) => {
                if (!element.hasAttribute("data-original-tabindex")) {
                  element.removeAttribute("tabindex");
                } else {
                  element.setAttribute("tabindex", element.getAttribute("data-original-tabindex"));
                }
              });
            }

            // Focus trap - keep focus within dropdown when open
            function handleFocusTrap(e) {
              if (e.key !== "Tab") return;

              let firstElement = backButton;
              let lastElement = focusableElements[focusableElements.length - 1];

              if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstElement) {
                  e.preventDefault();
                  lastElement.focus();
                }
              } else {
                // Tab
                if (document.activeElement === lastElement) {
                  e.preventDefault();
                  firstElement.focus();
                }
              }
            }

            // Initialize - disable focus in dropdown
            disableFocusInDropdown();

            function closeDropdown(closeMenu = false) {
              if (closeMenu) {
                crossButton.closest("#Details-menu-drawer-container").querySelector("summary").click();
              }
              dropdownMenu.classList.remove("is-visible");
              primaryNav.classList.remove("activated");
              navItemLink.setAttribute("aria-expanded", "false");
              disableFocusInDropdown();
              dropdownMenu.removeEventListener("keydown", handleFocusTrap);
            }

            function openDropdown() {
              dropdownMenu.classList.add("is-visible");
              primaryNav.classList.add("activated");
              navItemLink.setAttribute("aria-expanded", "true");
              enableFocusInDropdown();
              dropdownMenu.addEventListener("keydown", handleFocusTrap);
              backButton.focus();
            }

            // Back button - close dropdown
            backButton.addEventListener("click", () => closeDropdown());
            backButton.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                closeDropdown();
              }
            });

            // Cross button - close dropdown and menu
            crossButton.addEventListener("click", () => closeDropdown(true));
            crossButton.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                closeDropdown(true);
              }
            });

            // Menu link - open dropdown
            navItemLink.addEventListener("click", (e) => {
              e.preventDefault();
              openDropdown();
            });

            navItemLink.addEventListener("keydown", (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                openDropdown();
              }
            });

            // Escape key - close dropdown
            dropdownMenu.addEventListener("keydown", (e) => {
              if (e.key === "Escape") {
                closeDropdown();
              }
            });
          }
        });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    megaMenu();
    multipleDrawerMenuMobile();
  });
})();
